var $ = (typeof window !== "undefined" ? window['jQuery'] : typeof global !== "undefined" ? global['jQuery'] : null),
    breakpoint = 768; // todo improve this

function isEmpty($jq) {
    return $.trim($jq.val()).length === 0;
}

function onSearchClick(event) {
    var revealClass = 'js-reveal',
        $li = $(event.target).closest('.hsearch'),
        $form = $li.find('form');

    //if ($(window).width() < breakpoint && !isEmpty( $li.find('[type=search]') )) {
    //    // submit
    //    return $form.submit();
    //}

    if ($li.hasClass(revealClass) && !isEmpty( $li.find('[type=search]') )) {
        // submit
        return $form.submit();
    }

    $li.toggleClass(revealClass);
    event.preventDefault();
}

$(function () {
    $('.hsearch__searchicon').on('click', onSearchClick);
});
